import PubSub from 'pubsub-js';

export const getWindowSize = () => ({ width: window.innerWidth, height: window.innerHeight });

document.body.onresize = function() {
  PubSub.publish('onResize', getWindowSize());
};
